import { InfoIcon } from 'lucide-react';
import React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Icon,
  Stack,
} from '@crossnokaye/ux-common';

interface SequencerInstructionsProps {
  /** The instruction content specific to the sequencer type */
  children: React.ReactNode;
  /** Unique identifier for the accordion (used for accessibility and keys) */
  id: string;
}

/**
 * SequencerInstructions provides a collapsible accordion for sequencer-specific instructions.
 * The content is passed as children, allowing each sequencer type to define its own instructions.
 *
 * @example
 * <SequencerInstructions id="condenser">
 *   <Typography variant="body">
 *     Instructions for condenser sequencer...
 *   </Typography>
 * </SequencerInstructions>
 */
export const SequencerInstructions: React.FC<SequencerInstructionsProps> = ({ children, id }) => {
  return (
    <Accordion
      key={`accordion-${id}-sequencer-editor-instructions`}
      type="multiple"
      defaultValue={[]}
    >
      <AccordionItem value={`${id}-sequencer-editor-instructions`} className="border-0 px-0">
        <AccordionTrigger
          icon={<Icon icon={InfoIcon} variant="transparent" size="sm" color="text-primary" />}
          variant="small"
          title="Instructions"
          className="bg-[#191919] px-gutter-sm" // TODO: convertify to ux-common color. this is from the designs but not in ux-common yet.
        />
        <AccordionContent className="pt-thin p-2 select-text">
          <Stack className="select-text">{children}</Stack>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
